module.exports = __webpack_public_path__ + "3de2c5309413c8c83e1640c5be345c43.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Regular-Oblique.ttf
// module id = 403
// module chunks = 0